var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.127,
    cy: 10.127,
    r: 10.127,
    fill: "url(#paint0_radial_186_6609)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9516 5.28725C11.7143 7.07861 11.4639 8.96218 11.2134 10.8589C11.1475 11.3594 11.1344 11.8731 11.0025 12.3473C10.9366 12.5844 10.6466 12.7688 10.4621 12.9664C10.2644 12.7688 9.93486 12.5844 9.89532 12.3605C9.55261 9.98958 9.23626 7.61865 8.94627 5.24773C8.84082 4.33888 9.52625 3.60126 10.4094 3.57491C11.2793 3.54857 11.9648 4.27302 11.9516 5.28725Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6088 14.8366C11.6088 15.4688 11.0684 16.0089 10.4357 16.0089C9.80301 16.0089 9.28894 15.4688 9.28894 14.8234C9.28894 14.1648 9.80301 13.6643 10.4489 13.6643C11.0948 13.6643 11.6088 14.1912 11.6088 14.8366Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_186_6609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.254) rotate(135) scale(28.6434 27.1899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9158C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F9158C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#810DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152BAB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.d1cc2741f1168e931eeee112e63e5cce.svg";
export { ForwardRef as ReactComponent };